"use strict";
/**
 * @author Maxim Seredkin
 */

export default function () {
  return {
    restrict: "A",
    template: require("../view/table.html"),
    transclude: true,
    scope: {
      okvedData: "=?myOkvedData",
      resultData: "=?myResultData",
      loading: "=?myLoading",
    },
    controller: [
      "$scope",
      function ($scope) {
        $scope.rows = [
          [
            {
              name: "№ п\\п",
              rowSpan: 2,
            },
            {
              name: "Наименование проекта",
              rowSpan: 2,
            },
            {
              name: "Наименование населенного пункта, где реализуется/будет реализован проект",
              rowSpan: 2,
            },
            {
              name: "Ответственный исполнитель",
              rowSpan: 2,
              tooltip:
                "Ответственный исполнитель за реализацию проекта (наименование ОИВ и/или администрации ОМСУ, предприятия, организации, инвестора)",
            },
            {
              name: "Наименование программы (проекта)",
              rowSpan: 2,
              tooltip:
                "Наименование программы (проекта), в рамках которой(ого) осуществляется/планируется к осуществлению финансирование (в случае финансирования за счет бюджетных средств (областного и/или местного))",
            },
            {
              name: "ОКВЭД",
              rowSpan: 2,
              tooltip:
                "Вид экономической деятельности (номер и наименование подраздела ОКВЭД)",
            },
            {
              name: "Классификация предприятия",
              rowSpan: 2,
              tooltip:
                "Классификация предприятия (крупное, среднее, малое, ИП, микро)",
            },
            {
              name: "Период вложения инвестиций",
              rowSpan: 2,
            },
            {
              name: "Период",
              rowSpan: 2,
            },
            {
              name: "Объем инвестиций/финансирования, млн. руб.",
              colSpan: 4,
            },
            {
              name: "Ожидаемые результаты от реализации проектов/мероприятий",
              colSpan: 4,
            },
          ],
          [
            {
              name: "Всего",
            },
            {
              name: "Областной бюджет",
            },
            {
              name: "Местный бюджет",
            },
            {
              name: "Внебюджетные источники",
            },
            {
              name: "Объем отгруженной продукции, млн. руб.",
            },
            {
              name: "Объем товарооборота, млн. руб.",
            },
            {
              name: "Объем платных услуг, млн. руб.",
              tooltip: "Объем платных услуг (выполненных работ), млн. руб.",
            },
            {
              name: "Новые рабочие места, чел.",
            },
          ],
        ];
      },
    ],
  };
}
